import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCreateCategoryMutation } from '@modules/category';
import { MESSAGES } from '@app/constant';

import { createCategorySchema, initialFormState } from './data';
import { ICreateCategoryFormData } from './types';

export const useCreateCategoryLogic = () => {
  const [createCategory] = useCreateCategoryMutation()

  const [state, setState] = useState({
    isSuccess: '',
    isButtonLoading: false,
    isDeleteModalOpen: false,
  })

  const methods = useForm<ICreateCategoryFormData>({
    // @ts-ignore
    resolver: yupResolver(createCategorySchema),
    mode: 'onSubmit',
    defaultValues: initialFormState
  });

  const {
    reset,
    watch,
    register,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = methods;

  const onSubmit = async (data: ICreateCategoryFormData) => {
    setState((prev) => ({ ...prev, isButtonLoading: true, isSuccess: '' }))

    try {
      await createCategory(data).unwrap()

      reset()
      setState((prev) => ({
        ...prev,
        isButtonLoading: false,
        isSuccess: MESSAGES.categoryHasBeenSuccessfullyCreated
      }))
    } catch (error: any) {
      setState((prev) => ({
        ...prev,
        isButtonLoading: false,
        isSuccess: error?.data?.message || MESSAGES.somethingWentWrong
      }))
    }
  };

  return {
    ...state,
    methods,
    errors,
    watch,
    setState,
    onSubmit,
    register,
    handleSubmit,
  }
}
